export type DefaultMenuItem = {
  id: number;
  display_name: string;
  icon: string;
  href: string;
  sort_order: number;
  items?: DefaultMenuItem[];
};

export const DefaultItems: DefaultMenuItem[] = [
  {
    id: -1,
    display_name: "Dashboard",
    icon: "Home",
    href: "/dashboard",
    sort_order: 0,
  },
  {
    id: -2,
    display_name: "Help",
    icon: "HelpCircle",
    href: "/help",
    sort_order: 9999999,
  },
];

export const TenantAdminItems: DefaultMenuItem[] = [
  {
    id: -3,
    display_name: "Workflows",
    icon: "Workflow",
    href: "/workflows",
    sort_order: 10001,
  },
  {
    id: -4,
    display_name: "AI Agents",
    icon: "Bot",
    href: "/ai-agents",
    sort_order: 10002,
  },
  {
    id: -5,
    display_name: "Files",
    icon: "FileImage",
    href: "/files",
    sort_order: 10003,
  },
  {
    id: -6,
    display_name: "AnythinkPay",
    icon: "CreditCard",
    href: "/integrations/anythinkpay",
    sort_order: 10004,
  },
  {
    id: -9,
    display_name: "Growth",
    icon: "TrendingUp",
    href: "/growth",
    sort_order: 10005,
  },
  {
    id: -7,
    display_name: "API Docs",
    icon: "Code",
    href: "/api-docs",
    sort_order: 10006,
  },
  {
    id: -8,
    display_name: "Settings",
    icon: "Settings",
    href: "/settings",
    sort_order: 10007,
  },
];
